"use strict";

var _create = require("babel-runtime/core-js/object/create");

var _create2 = _interopRequireDefault(_create);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Object.defineProperty(exports, "__esModule", { value: true });
var scriptjs = require("scriptjs");
var jsonp = require("jsonp");
var queryString = require("query-string");
var lodash_alt_1 = require("./lodash-alt");
exports.PANE_LEVEL_KEYS = ["country", "province", "city", "area", "town"];
exports.ADDRTREE_ROOT_NAME = "GLOBAL_MAGIC_PLANET_EARTH";
exports.ADDRTREE_ROOT_KEY = "0";
exports.ADDRTREE_ROOT_LEVEL_KEY = "GLOBAL_MAGIC_PLANET_EARTH_LEVEL_KEY";
exports.CACHE_COMP_VERSION = 11;
exports.PANE_LEVELS = ["province", "city", "area", "town"];
exports.PANE_ATTRIBUTES = {
    "country": {
        index: 0,
        field: "country",
        title: {
            'zh-cn': "国家",
            'zh-tw': "國家",
            'en-us': "country"
        }
    },
    "province": {
        index: 1,
        field: "province",
        title: {
            'zh-cn': "省",
            'zh-tw': "省",
            'en-us': "province"
        }
    },
    "city": {
        index: 2,
        field: "city",
        title: {
            'zh-cn': "市",
            'zh-tw': "市",
            'en-us': "city"
        }
    },
    "area": {
        index: 3,
        field: "area",
        title: {
            'zh-cn': "区",
            'zh-tw': "區",
            'en-us': "area"
        }
    },
    "town": {
        index: 4,
        field: "town",
        title: {
            'zh-cn': "街道",
            'zh-tw': "街道",
            'en-us': "town"
        }
    }
};
function topologySort(allNodesSet) {
    var nodesWithoutParent = [],
        unsortedNodeKeys = (0, _keys2.default)(allNodesSet);
    while (unsortedNodeKeys.length) {
        var thisNodeKey = unsortedNodeKeys.pop();
        var thisNode = allNodesSet[thisNodeKey];
        if (thisNode.parent !== null) {
            if (allNodesSet[thisNode.parent]) {
                allNodesSet[thisNode.parent].children.push(thisNode);
            }
        } else {
            nodesWithoutParent.push(thisNode);
        }
    }
    return nodesWithoutParent;
}
exports.topologySort = topologySort;
function preprocessRawAddressData(params, rawData, ignored, isLeaf) {
    if (ignored === void 0) {
        ignored = {};
    }
    if (isLeaf === void 0) {
        isLeaf = false;
    }
    var allNodesSet = {};
    for (var rawNodeID in rawData) {
        if (!Object.prototype.hasOwnProperty.call(ignored, rawNodeID)) {
            var rawNode = rawData[rawNodeID];
            var processed = {
                id: rawNodeID,
                parent: rawNode[1],
                nameZh: rawNode[0],
                namePy: rawNode[2],
                nameEn: rawNode[3] || "",
                value: rawNodeID,
                label: rawNode[0]
            };
            if (isLeaf) {
                processed.isLeaf = true;
            } else {
                processed.children = [];
            }
            allNodesSet[rawNodeID] = processed;
        }
    }
    return allNodesSet;
}
exports.preprocessRawAddressData = preprocessRawAddressData;
function loadAddressData(params) {
    var ignored = params.ignored,
        dataOverride = params.dataOverride,
        preprocessor = params.preprocessor;
    var ignoredMap = ignored ? lodash_alt_1.zipObject(ignored, new Array(ignored.length).fill(true)) : null;
    return new _promise2.default(function (resolve, reject) {
        scriptjs(params.addressURL, function () {
            var rawDataOrg = window.tdist;
            var rawData = (0, _create2.default)(null);
            var mergeData = function mergeData(dict, strict) {
                return (0, _keys2.default)(dict).forEach(function (k) {
                    if (Array.isArray(dict[k])) {
                        rawData[k] = dict[k].slice();
                    } else if (strict) {
                        console.warn("CNAddress: invalid value for id ", k);
                    }
                });
            };
            mergeData(rawDataOrg, false);
            dataOverride && mergeData(dataOverride, true);
            typeof preprocessor == "function" && preprocessor(rawData);
            rawData[exports.ADDRTREE_ROOT_KEY] = [exports.ADDRTREE_ROOT_NAME, null, exports.ADDRTREE_ROOT_NAME, exports.ADDRTREE_ROOT_NAME];
            var allNodesSet = preprocessRawAddressData(params, rawData, ignoredMap);
            var nodesWithoutParent = topologySort(allNodesSet);
            nodesWithoutParent.forEach(function sortChildrenRecursive(node) {
                node.children.forEach(sortChildrenRecursive);
                node.children.sort(function (lhs, rhs) {
                    return parseInt(lhs.id) - parseInt(rhs.id);
                });
            });
            nodesWithoutParent.forEach(function labelLevel(level, node) {
                node.level = level;
                node.children.forEach(labelLevel.bind(null, level + 1));
            }.bind(null, -1));
            // add "levelKey" attribute
            nodesWithoutParent.forEach(function (node) {
                return node.levelKey = exports.ADDRTREE_ROOT_LEVEL_KEY;
            });
            nodesWithoutParent.forEach(function labelLevelKey(level, node) {
                if (level >= 0) {
                    node.levelKey = exports.PANE_LEVEL_KEYS[level];
                }
                node.children.forEach(labelLevelKey.bind(null, level + 1));
            }.bind(null, -1));
            // add "parentNode" attribute
            nodesWithoutParent.forEach(function labelParentNode(parentNode, node) {
                node.parentNode = parentNode;
                node.children.forEach(labelParentNode.bind(null, node));
            }.bind(null, null));
            nodesWithoutParent.forEach(function leaveifyChildlessCountry(node) {
                if (node.levelKey == "country" && !node.children.length) {
                    node.isLeaf = true, node.children = undefined;
                } else {
                    node.children.forEach(leaveifyChildlessCountry);
                }
            });
            nodesWithoutParent.forEach(function markCountry(country, node) {
                if (country === null) {
                    node.ofCountry = "0";
                } else {
                    node.ofCountry = country;
                }
                if (node.children) {
                    if (node.levelKey == "country") {
                        node.children.forEach(markCountry.bind(null, node.id));
                    } else {
                        node.children.forEach(markCountry.bind(null, country));
                    }
                }
            }.bind(null, null));
            nodesWithoutParent.forEach(function annotatePy(node) {
                node.namePy = node.namePy.toLowerCase();
                node.namePyJoined = node.namePy.replace(/\ /g, '');
                node.namePyAbbr = (node.namePy.match(/\b([a-zA-Z])/g) || []).join('');
                if (node.children) {
                    node.children.forEach(annotatePy);
                }
            });
            resolve({
                countryList: [].concat.apply([], nodesWithoutParent.map(function (n) {
                    return n.children.map(function (node) {
                        return { value: node.value, label: node.label };
                    });
                })),
                allNodesSet: allNodesSet,
                addressTree: nodesWithoutParent[0] // [0].children
            });
        });
    });
}
exports.loadAddressData = loadAddressData;
function selectionToChain(value) {
    return exports.PANE_LEVEL_KEYS // keys array, must be in order
    .map(function (key) {
        return value[key];
    })
    // necessary because there is cases that one or more
    //  intermediate levels with no value
    .filter(function (v) {
        return !!v;
    });
}
exports.selectionToChain = selectionToChain;
function nodeChainFromNode(node) {
    if (!node) return [];
    return (!node.parentNode ? [] : nodeChainFromNode(node.parentNode)).concat(node);
}
exports.nodeChainFromNode = nodeChainFromNode;
function foldNodeChainToSelection(nodeChain) {
    var ret = {};
    nodeChain.forEach(function (node) {
        return ret[node.levelKey] = node.id;
    });
    return ret;
}
exports.foldNodeChainToSelection = foldNodeChainToSelection;
function loadTownData(reqParams, node) {
    // output_address_town returns a huge blob of useless data
    //  when used against a country
    if (node.levelKey == "country") {
        return _promise2.default.resolve([]);
    }
    var selectionChain = nodeChainFromNode(node).slice(1);
    var params = {};
    for (var i = 0; i < selectionChain.length; i++) {
        params["l" + i] = selectionChain[i].id;
    }
    return new _promise2.default(function (resolve, reject) {
        var url = reqParams.townURL + "?" + queryString.stringify(params);
        jsonp(url, function (err, data) {
            if (err) {
                return reject(err);
            }
            // TODO: throw the Right error
            if (!data.success) {
                return reject(data);
            }
            var rawData = data.result;
            var townsSet = preprocessRawAddressData(reqParams, rawData, {} /* ignored */, true);
            var townsList = (0, _keys2.default)(townsSet).map(function (key) {
                return townsSet[key];
            });
            townsList.sort(function (lhs, rhs) {
                return parseInt(lhs.id) - parseInt(rhs.id);
            });
            // townsList.forEach(n => (n.level = node.level + 1));
            townsList.forEach(function (n) {
                return n.level = 4;
            });
            townsList.forEach(function (n) {
                return n.levelKey = "town";
            });
            townsList.forEach(function (n) {
                return n.parentNode = node;
            });
            resolve(townsList);
        });
    });
}
exports.loadTownData = loadTownData;
function traceTownParents(_a, divisionId, allNodesSet) {
    var parentURL = _a.parentURL;
    return new _promise2.default(function (resolve, reject) {
        var url = parentURL + "?" + queryString.stringify({ divisionId: divisionId });
        jsonp(url, function (err, data) {
            if (err) {
                return reject(err);
            }
            var ret = {};
            (0, _keys2.default)(data).forEach(function (key) {
                return data[key] && (ret[key] = data[key].id);
            });
            if (!ret.hasOwnProperty("country")) {
                ret.country = "1";
            }
            resolve(selectionToChain(ret));
        });
    });
}
exports.traceTownParents = traceTownParents;
function defaultTextSerializer(nodeChain) {
    return nodeChain.map(function (x) {
        return x.nameZh;
    }).join("");
}
exports.defaultTextSerializer = defaultTextSerializer;
function standardValueEqual(lhs, rhs) {
    for (var key in lhs) {
        if (!(key in rhs) || lhs[key] != rhs[key]) {
            return false;
        }
    }
    for (var key in rhs) {
        if (!(key in lhs) || lhs[key] != rhs[key]) {
            return false;
        }
    }
    return true;
}
exports.standardValueEqual = standardValueEqual;
exports.addressTreeOfSet = function (allNodesSet) {
    return allNodesSet[exports.ADDRTREE_ROOT_KEY];
};
exports.delay = function (n) {
    if (n === void 0) {
        n = 0;
    }
    return new _promise2.default(function (resolve, reject) {
        return setTimeout(function () {
            return resolve();
        }, n);
    });
};
exports.id = function (v) {
    return v;
};
//# sourceMappingURL=util.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-address@0.0.80@@alicd/crui-address/lib/util.js
// module id = 101
// module chunks = 0